// Mock data for Vitanza Logistics website

export const companyInfo = {
  name: "Vitanza Logistics",
  tagline: "Your Trusted Partner in Transportation Excellence",
  email: "dispatch@vitanzalogistics.com",
  phone: "(905) 917-2152",
  phoneTel: "+19059172152",
  address: "454 - 7100 Woodbine Avenue, Markham, ON L3R 5J2",
  established: "2024",
};

const SERVICE_TYPE_LABELS = {
  freight: "Freight & Long Haul",
  logistics: "Logistics & Warehousing",
  crossborder: "Cross Border US-Canada",
  ftl: "FTL (Full Truckload)",
  ltl: "LTL (Less Than Truckload)",
  reefer: "Reefer Services",
};

export const services = [
  {
    id: 1,
    title: "Freight & Long Haul",
    description:
      "Reliable long-distance freight transportation across North America with real-time tracking and dedicated support.",
    icon: "truck",
    features: [
      "Cross-country delivery",
      "Temperature controlled",
      "24/7 monitoring",
    ],
  },
  {
    id: 2,
    title: "Logistics & Warehousing",
    description:
      "Comprehensive warehousing solutions with inventory management, order fulfillment, and distribution services.",
    icon: "warehouse",
    features: [
      "Climate controlled facilities",
      "Inventory management",
      "Order fulfillment",
    ],
  },
  {
    id: 3,
    title: "Cross Border US-Canada",
    description:
      "Seamless cross-border shipping between USA and Canada with expert customs clearance and documentation.",
    icon: "globe",
    features: [
      "Customs clearance",
      "Documentation support",
      "Fast border crossing",
    ],
  },
  {
    id: 4,
    title: "FTL (Full Truckload)",
    description:
      "Full truckload services for large shipments requiring dedicated transportation and faster delivery times.",
    icon: "container",
    features: [
      "Dedicated trucks",
      "Direct delivery",
      "Cost-effective for large loads",
    ],
  },
  {
    id: 5,
    title: "LTL (Less Than Truckload)",
    description:
      "Cost-efficient LTL shipping for smaller freight, sharing space with other shipments to optimize costs.",
    icon: "package",
    features: ["Flexible pickup", "Affordable rates", "Consolidated shipping"],
  },
  {
    id: 6,
    title: "Reefer Services",
    description:
      "Temperature-controlled refrigerated transportation for perishables, pharmaceuticals, and sensitive goods.",
    icon: "snowflake",
    features: [
      "Temperature monitoring",
      "Perishable goods",
      "Pharmaceutical grade",
    ],
  },
];

export const stats = [
  { number: "EST. 2024", label: "Established" },
  { number: "5000+", label: "Deliveries Monthly" },
  { number: "98%", label: "On-Time Delivery" },
  { number: "24/7", label: "Customer Support" },
];

export const whyChooseUs = [
  {
    title: "Reliable & On-Time",
    description:
      "98% on-time delivery rate with real-time tracking and proactive communication.",
    icon: "clock",
  },
  {
    title: "Safety First",
    description:
      "DOT compliant with comprehensive insurance coverage and safety protocols.",
    icon: "shield",
  },
  {
    title: "Modern Fleet",
    description:
      "Well-maintained trucks equipped with GPS tracking and temperature control.",
    icon: "truck",
  },
  {
    title: "Experienced Team",
    description:
      "Professional drivers and logistics experts dedicated to your success.",
    icon: "users",
  },
];

export const submitContactForm = async (formData) => {
  const serviceLabel =
    SERVICE_TYPE_LABELS[formData.serviceType] || formData.serviceType;

  const res = await fetch(
    `https://formsubmit.co/ajax/${encodeURIComponent(companyInfo.email)}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        _subject: `Quote request — ${formData.name} (${serviceLabel})`,
        _template: "table",
        _captcha: false,
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        company: formData.company || "—",
        service: serviceLabel,
        message: formData.message,
      }),
    }
  );

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg =
      typeof data.message === "string"
        ? data.message
        : "Submission failed. Please try again or email us directly.";
    throw new Error(msg);
  }

  return {
    success: true,
    message: "Thank you! We'll contact you within 24 hours.",
  };
};
